import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  result: undefined,
  error: undefined,
};

const change = (store, data) => {
  store.setState((state) => {
    state.app.usuarios.permissions.data = data;
  });
};

const permissions = async (store, id, params = {}) => {
  store.setState((state) => {
    state.app.usuarios.permissions.busy = true;
  });

  try {
    const response = await Http.get(`api/permisos`, { params });

    store.setState((state) => {
      state.app.usuarios.permissions.data = response.data;
      state.app.usuarios.permissions.busy = false;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.usuarios.permissions.error = error.data || error;
      state.app.usuarios.permissions.busy = false;
    });
  }
};

const UsuarioPermissionStore = {
  state: () => initialState,
  actions: {
    permissions,
    change,
  },
};

export default UsuarioPermissionStore;
